import { normalizeHttpFailure } from '../../api/normalizeApiError'

/**
 * Mantida a assinatura original para não mexer em resendOtp/validateOtp — a
 * extração em si passou a ser a mesma do resto do app (normalizeApiError),
 * que também cobre os formatos legados de erro do middleware.
 */
export default function extractOtpMessage(data: unknown, fallback: string): string {
  const erro = normalizeHttpFailure(0, data)

  return erro.usedFallback ? fallback : erro.message
}
